<template>
    <div class="body">
		<p  class="font1" style="padding-top: 8vh;">在追求知识的道路上，ESG课程引领我们关注全球责任。让我们共同践行，成就美好未来！</p>

		<div style="width: 90%;margin: 0 auto;margin-top: 2vh;">
			<p style="margin: 0 auto; font-size: 20px;color: #000;">EHS+ESG 五月主题课程推荐：</p>
			<ul>
				<a @click="redirectToESG('产品之识别与追溯性','https://iedu.foxconn.com/public/play/play?courseId=53994&companyId=179')" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">产品之识别与追溯性</li></a>
				<a @click="redirectToESG('品质意识','https://iedu.foxconn.com/public/play/play?courseId=53993&companyId=179')" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">品质意识</li></a>
				<a @click="redirectToESG('现场职业健康卫生管理','https://iedu.foxconn.com/public/play/play?courseId=53296&companyId=155')" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">现场职业健康卫生管理</li></a>
				<a @click="redirectToESG('员工心理健康小课堂','https://iedu.foxconn.com/public/play/play?courseId=49699&companyId=179')"  style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">员工心理健康小课堂</li></a>
				<a @click="redirectToESG('品质管制','https://iedu.foxconn.com/public/play/play?courseId=48324&companyId=40')" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">品质管制 </li></a>
				<a @click="redirectToESG('精益生产之流程管理','https://iedu.foxconn.com/public/play/play?courseId=36894&companyId=2')" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">精益生产之流程管理</li></a>
			</ul>
		</div>
		<!-- <div style="width: 87%;margin: 0 auto;margin-top: 3vh;" v-if="coc">
			<p style="margin: 0 auto; font-size: 20px;color: #000;">必修课程完成情况：</p>
			<ul v-for="(item,index) in coc" :key="index" ref="">
				<a @click="redirectToESG(item.Name, item.link)" style="text-decoration: none;color: #000;">
					<li style="padding: 0;margin-top: 0;">{{ item.Name }}&nbsp;
						<span v-if="item.iscompleted" style="color: green;font-weight: 800;">已完成</span>
						<span v-else style="color: red;font-weight: 800;">未完成</span>
					</li>
				</a>
			</ul>
		</div> -->

    </div>
</template>
  
<script>
export default {
    props: ["ReportData"],
    data() {
		return {
			coc:[],
		}
    }, 
    methods: {
        redirectToESG(esgName,esgUrl) {
            var dataForm = {};
            dataForm.clickEsgName = esgName
            dataForm.clickEsgLink = esgUrl
            this.$emit('redirectToESG',dataForm);
        }
    },
    created(){
		if(this.ReportData.coc !== null){
			this.coc=JSON.parse(this.ReportData.coc)
            // console.log(this.coc,'coc')
		}
    },
}
</script>
  
<style scoped>
.body {
	background: 
        url("../../assets/25March/logo.png") right  top  no-repeat,
        url("../../assets/25April/bg.jpg")  no-repeat;
	background-size: 100% 100%,cover;
	width: 100%;
	height: 100vh;
}

ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    margin: 0;
    /* text-align: center; */
}

li {
    align-items: center;
    /* margin-bottom: 1px;  */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}

.font1 {
    width: 96%;
    margin: 0 auto;
    /* text-align: center; */
    font-size: 20px;
    color: #26a5e1;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font2 { 
    width: 96%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #64892f;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>